import { render, staticRenderFns } from "./productTj.vue?vue&type=template&id=8725a730&scoped=true&"
import script from "./productTj.vue?vue&type=script&lang=js&"
export * from "./productTj.vue?vue&type=script&lang=js&"
import style0 from "./productTj.vue?vue&type=style&index=0&id=8725a730&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8725a730",
  null
  
)

export default component.exports